

export default {

  actions: {
    1: ['kill', 'feed'],
    3: ['kill', 'feed', 'neutral'],
  },

  shapes: [
    'circle',
    'rectangle',
    'triangle',
    'blot', // клякса
    // 'line',
    'star',
    'pentagon',
    'arrow',
  ],

  texts: [

    // Objects
    'dinosaur',
    'sun',
    'universe',
    'molecule',
    'substance',
    'nanotube',
    'space',

    // Время
    'moment',
    'second',
    'millisecong',
    'hour',
    'day',
    'week',
    'month',
    'year',
    'century',

    // Математика, наука
    'plus',
    'minus',
    'equality',
    'geometry',
    'science',
    'hypothesis',
    'proof',
    'algorithm',
    'formula',
    'word',
    'power',
    'infinity',
    'zero',
    'metre',
    'value',
    'position',
    'state',
    'width',
    'height',
    'size',

    // Глаголы
    'waiting',

    // Совсем абстрактное
    'sense',
    'nonsense',
    'agreement',
    'denial',
    'way',
    'criterion',
    'abstract',
    'illusion',
    'reality',
    'idea',
    'identity',
    'existence',
    'specificity',
    'essence', // Сущность
    'possibility',
    'competence',
    'principe',

    // Другое
    'impact', // Влияние
    'term',
    'context',
    'demonstration',
    
  ],

}